import { useLocation } from 'react-router';
import useSWR from 'swr';
import { trpc } from '../config/trpc';

export function useOnboardContractorExisting() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get('invite-token');
  const { data, isLoading, error, isValidating } = useSWR(
    {
      token,
    },
    async () => trpc.onboard.getInvitedOrg.query({ inviteToken: token ?? '' })
  );
  return {
    data,
    isLoading,
    error,
    isValidating,
    onboardContractorExistingUser: async (orgName: string) =>
      trpc.onboard.onboardContractorExistingUser.mutate({
        inviteToken: token ?? '',
        orgName,
      }),
    onboardLinkContractorExistingUser: async (userOrgId: string) =>
      trpc.onboard.onboardLinkContractorExistingUser.mutate({
        userOrgId,
        inviteToken: token ?? '',
      }),
  };
}
